<template>
  <div>
    <div style="border: 1px solid #ccc; margin-top: 10px;">
      <!-- 工具栏 -->
      <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" />
      <!-- 编辑器 -->
      <Editor style="height: 400px; overflow-y: hidden;" :defaultConfig="editorConfig" v-model="html"
              @onChange="onChange" @onCreated="onCreated" />
    </div>

  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
  name: 'MyEditor',
  components: { Editor, Toolbar },
  data() {
    return {
      editor: null,
      html: '',
      url:'https://api.huceen.com/huichen-ui/upload/file',//上传地址
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        excludeKeys: [
          'codeBlock',// 删除代码块
          'insertTable',// 删除表格
          'blockquote',// 删除引用
          'group-more-style',// 删除更多样式
          'italic',// 删除斜体
          'todo',// 删除代办
          'code',// 删除代码
          'emotion',// 删除表情
          'fontFamily',// 删除字体
          'insertLink',// 删除链接
          'insertImage',//删除网络上传
          'insertVideo',//删除视频
          'fullScreen',//删除全屏
          'divider',//删除分割线
        ],
      },
      editorConfig: {
        placeholder: '请输入内容...',
        // autoFocus: false,

        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {},
        }
      }
    }
  },
  created() {
    console.log(this.editorConfig, 'this.editorConfig.MENU_CONF')
    this.editorConfig.MENU_CONF['uploadVideo'] = {
      // form-data fieldName ，默认值 'wangeditor-uploaded-image'
      server: this.url,
      fieldName: 'file',

      // 单个文件的最大体积限制，默认为 2M
      maxFileSize: 100 * 1024 * 1024, // 1M

      // 最多可上传几个文件，默认为 100
      maxNumberOfFiles: 10,

      // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
      allowedFileTypes: ['video/*'],

      // 自定义增加 http  header
      headers: {
        'Accept': '*/*',
        'token': localStorage.getItem('logintoken') //头部token
      },
      // 自定义插入图片
      customInsert(res, insertFn) {  // TS 语法
        console.log(res, insertFn)
        insertFn(res.data)
      },
      // 上传之前触发 // 上传之前触发
      onBeforeUpload(file) {
        console.log('onBeforeUpload', file)
        return file
      },

      // 上传进度的回调函数
      onProgress(progress) {
        console.log('progress', progress)
      },

      // 单个文件上传成功之后
      onSuccess(file, res) {
        console.log(`${file.name} 上传成功`, res)
      },

      // 单个文件上传失败
      onFailed(file, res) {
        console.log(`${file.name} 上传失败`, res)
      },

      // 上传错误，或者触发 timeout 超时
      onError(file, err, res) {
        console.log(`${file.name} 上传出错`, err, res)
      }
    }
    this.editorConfig.MENU_CONF['uploadImage'] = {
      // form-data fieldName ，默认值 'wangeditor-uploaded-image'
      server: this.url,
      fieldName: 'file',
      // 单个文件的最大体积限制，默认为 2M
      maxFileSize: 100 * 1024 * 1024, // 1M

      // 最多可上传几个文件，默认为 100
      maxNumberOfFiles: 10,

      // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
      allowedFileTypes: ['image/*'],

      // 自定义增加 http  header
      headers: {
        'Accept': '*/*',
        'token': localStorage.getItem('logintoken') //头部token
      },
      // 自定义插入图片
      customInsert(res, insertFn) {  // TS 语法
        console.log(res, insertFn)
        insertFn(res.data)
      },
      // 上传之前触发 // 上传之前触发
      onBeforeUpload(file) {
        console.log('onBeforeUpload', file)
        return file
      },

      // 上传进度的回调函数
      onProgress(progress) {
        console.log('progress', progress)
      },

      // 单个文件上传成功之后
      onSuccess(file, res) {
        console.log(`${file.name} 上传成功`, res)
      },

      // 单个文件上传失败
      onFailed(file, res) {
        console.log(`${file.name} 上传失败`, res)
      },

      // 上传错误，或者触发 timeout 超时
      onError(file, err, res) {
        console.log(`${file.name} 上传出错`, err, res)
      }
    }
  },
  methods: {
    echo(editor){
      this.html = editor
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
      this.editor.children.map(item=>{
        item.children.map(ele=>{
          if(ele.text == ''){//这样粘贴过来的格式不会改变
            ele.fontSize='12px'
          }
        })
      })

      this.editor.config.lineHeights = ['2.5']


    },
    onChange(editor) {
      this.$emit('catchData', editor.getHtml());
    },
    insertTextHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.insertText(' hello ')
    },
    printEditorHtml() {
      const editor = this.editor
      if (editor == null) return
      console.log(editor.getHtml())
    },
    disableHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.disable()
    }
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器

  },

  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>



// WEBPACK FOOTER //
// src/components/wangeditor.vue